"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.clearIconSize = exports.searchIconSize = exports.inputPlaceholder = exports.inputType = exports.searchInputRole = exports.searchRole = exports.classes = void 0;
var classes = {
  container: 'container',
  searchContainer: 'search-container',
  searchBox: 'search-box',
  searchIconBox: 'search-icon-box',
  clearIcon: 'clear-icon',
  searchIcon: 'search-icon',
  searchContainerDisabled: 'search-container-disabled',
  searchBoxDisabled: 'search-box-disabled',
  searchIconDisabled: 'search-icon-disabled',
  clearIconDisabled: 'clear-icon-disabled'
};
exports.classes = classes;
var searchRole = 'search';
exports.searchRole = searchRole;
var searchInputRole = 'searchbox';
exports.searchInputRole = searchInputRole;
var inputType = 'search';
exports.inputType = inputType;
var inputPlaceholder = 'Search';
exports.inputPlaceholder = inputPlaceholder;
var searchIconSize = 24;
exports.searchIconSize = searchIconSize;
var clearIconSize = 24;
exports.clearIconSize = clearIconSize;